module.exports = __webpack_public_path__ + "img/event4.39630be0.png";